import React from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { Delete } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const PermanentlyDeleteOKRConfirmationModal = ({ isObjective, isOpen, onClose, handleUnarchiveOkr }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const BodyComp = <ModalBody isObjective={isObjective} />;

  return (
    <>
      {/* @ts-ignore */}
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        title={
          <>
            <Delete style={{ marginRight: '4px' }} />
            <span>Permanently Delete {isObjective ? objectivesName : keyResultsName}</span>
          </>
        }
        body={BodyComp}
        cancelText="Cancel"
        onCancel={onClose}
        continueText="Delete Permanently"
        onContinue={handleUnarchiveOkr}
      />
    </>
  );
};

const ModalBody = ({ isObjective }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  return (
    <TextBodyMedium>
      Permanently deleting this{' '}
      {isObjective
        ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
        : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}{' '}
      will also delete all the child {modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)} aligned to it, and
      we may not be able to restore the same. Are you sure you want to continue?
    </TextBodyMedium>
  );
};
